import { render, staticRenderFns } from "./terms-of-use-container.vue?vue&type=template&id=b94b28de"
import script from "./terms-of-use-container.vue?vue&type=script&lang=js"
export * from "./terms-of-use-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports